import { Controller } from "stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {

  static targets = [ "navbar", "shared_with", "shared_public", "btnSend", "btnCancel", "inputFileSid", "inputFileName", "progressbar"]

  static values = {
    page: String,
    filter: String
  }

  connect() {
    if(this.hasNavbarTarget) {
      let navLink;
      if(this.filterValue == "shared") {
        navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
      } else if(this.filterValue == "projects") {
        navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
      } else {
        navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
      }

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }
  }

  toggleShareWith() {
    switch(event.target.value) {
      case "shared":
        this.shared_publicTarget.classList.add('d-none')
        this.shared_withTarget.classList.remove('d-none')
        break;
      case "public":
        this.shared_withTarget.classList.add('d-none')
        this.shared_publicTarget.classList.remove('d-none')
        break;
      default:
        this.shared_publicTarget.classList.add('d-none')
        this.shared_withTarget.classList.add('d-none')
    }
  }

  selectFile() {
    var div = event.target.closest("div");
    var input = div.querySelector("#filepicker");
    input.click();
  }

  fileSelected() {
    let inp = event.target.closest("div").querySelector("input[type='text']");
    inp.value = event.target.value;
    if(event.target.files[0].size > 536870912) {
      this.btnSendTarget.setAttribute('disabled', true);
      this.btnSendTarget.classList.add('disabled');
      alert("<%= t('file.max_size_exceeded') %>");
      return;
    } else {
      if(this.inputFileNameTarget.value.trim() == '') {
        this.inputFileNameTarget.value = event.target.files[0].name;
      }
      this.btnSendTarget.removeAttribute('disabled');
      this.btnSendTarget.classList.remove('disabled');
    }
  }

  uploadFile() {
    let that = this;
    var input = document.querySelector("#filepicker");

    this.btnSendTarget.setAttribute('disabled', true);
    this.btnCancelTarget.setAttribute('disabled', true);
    this.btnSendTarget.innerHTML = `<i class="fa-solid fa-spinner fa-spin-pulse fa-fw"></i>${I18n.t('file.uploading')}...`

    const url = input.dataset.directUploadUrl;

    var files = input.files.length;
    var count = 0;

    Array.from(input.files).forEach(file => {
      const upload = new DirectUpload(file, url, this);

      upload.create((error, blob) => {
        if (error) {
          console.log(`ERROR: ${error}`);
          this.btnSendTarget.innerHTML = `<i class="fa-solid fa-upload"></i>${I18n.t('file.upload')}`
          that.btnSendTarget.removeAttribute('disabled');
          that.btnCancelTarget.removeAttribute('disabled');
        } else {
          that.inputFileSidTarget.value = blob.signed_id;
          var form = document.querySelector("form#file-new");
          Rails.fire(form, 'submit');
          bootbox.hideAll();
        }

      })
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    console.log(event)
    var progress = parseInt(event.loaded / event.total * 100, 10);
    this.progressbarTarget.style.width = `${progress}%`;
    this.progressbarTarget.setAttribute('aria-valuenow', progress);
    this.progressbarTarget.innerHTML = `${progress} %`;
  }
}
